function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useRef, useEffect, useCallback, memo } from 'react';
import styled from 'styled-components';
import InfoIcon from './InfoIcon.js';
import TooltipContent, { ARROW_SIZE, ARROW_DISTANCE } from './TooltipContent.js';
import { jsxs, jsx } from 'react/jsx-runtime';
const useTooltip = () => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldRender = _useState2[0],
    setShouldRender = _useState2[1];
  const tooltipRef = useRef(null);
  const _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    offset = _useState4[0],
    setOffset = _useState4[1];
  useEffect(() => {
    if (!tooltipRef.current) return;

    // Only calculate offset once and only when visible
    if (offset || !shouldRender) return;
    const tooltipEl = tooltipRef.current.getBoundingClientRect();
    const newOffset = {
      left: -tooltipEl.width / 2,
      top: 0
    };

    // Calculate whether tooltip is out of bounds of window
    if (window.innerWidth - tooltipEl.right - newOffset.left < 0) {
      newOffset.left = Math.round(window.innerWidth - tooltipEl.right);
    }
    if (tooltipEl.left + newOffset.left < 0) {
      newOffset.left = Math.round(Math.abs(tooltipEl.left));
    }
    if (window.innerHeight - tooltipEl.bottom < 0) {
      newOffset.top = Math.round(window.innerHeight - tooltipEl.bottom);
    }
    if (tooltipEl.top < 0) {
      newOffset.top = Math.round(Math.abs(tooltipEl.top));
    }
    setOffset(newOffset);
  }, [tooltipRef, shouldRender]);
  return {
    shouldRender,
    setShouldRender,
    tooltipRef,
    offset,
    isVisible: !!(shouldRender && offset)
  };
};
function Tooltip({
  content
}) {
  const _useTooltip = useTooltip(),
    shouldRender = _useTooltip.shouldRender,
    setShouldRender = _useTooltip.setShouldRender,
    offset = _useTooltip.offset,
    tooltipRef = _useTooltip.tooltipRef,
    isVisible = _useTooltip.isVisible;
  const showTooltip = useCallback(() => setShouldRender(true), [setShouldRender]);
  const hideTooltip = useCallback(() => setShouldRender(false), [setShouldRender]);
  return /*#__PURE__*/jsxs(Container, {
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip,
    onFocus: showTooltip,
    onBlur: hideTooltip,
    tabIndex: 0,
    children: [shouldRender && /*#__PURE__*/jsx(Wrapper, {
      style: {
        left: offset?.left ?? 0,
        top: offset?.top ?? 0
      },
      visible: isVisible,
      children: /*#__PURE__*/jsx(TooltipContent, {
        content: content,
        ref: tooltipRef
      })
    }, "tooltip"), /*#__PURE__*/jsx(InfoIcon, {})]
  });
}
const Container = styled.div`
  /*
  * Invisible extra padding to prevent losing focus as
  * the mouse moves to the tooltip
  */
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: ${ARROW_SIZE}px;
    height: ${ARROW_DISTANCE}px;
    bottom: ${ARROW_DISTANCE}px;
  }
`;
const Wrapper = styled.div.withConfig({
  shouldForwardProp: p => !['visible'].includes(p)
})`
  position: relative;
  opacity: ${({
  visible
}) => visible ? '1' : '0'};
  transition: opacity 100ms;
`;
const Tooltip$1 = /*#__PURE__*/memo(Tooltip);
export { Tooltip$1 as default, useTooltip };
//# sourceMappingURL=Tooltip.js.map
